import { useEffect, useRef } from 'react';
import type { RunningHubFeatureType } from '../types/runningHubJobs';
import {
  stripJobMetaFromPayload,
  type RunningHubRecoveryRequest,
} from '../utils/applyRunningHubJobRecovery';

export function useRunningHubPanelRecovery<T extends { id: string }>(opts: {
  featureType: RunningHubFeatureType;
  recoveryRequest?: RunningHubRecoveryRequest | null;
  mapPayloadToItem: (payload: Record<string, unknown>) => T | null;
  applyItem: (item: T) => void;
  mergeHistory?: (item: T) => void;
}): void {
  const lastJobRef = useRef<string | null>(null);

  useEffect(() => {
    const req = opts.recoveryRequest;
    if (!req || req.featureType !== opts.featureType) return;
    if (lastJobRef.current === req.jobId) return;
    lastJobRef.current = req.jobId;

    const item = opts.mapPayloadToItem(stripJobMetaFromPayload(req.historyPayload));
    if (!item) return;
    opts.mergeHistory?.(item);
    opts.applyItem(item);
  }, [opts.recoveryRequest, opts.featureType, opts.mapPayloadToItem, opts.applyItem, opts.mergeHistory]);
}
